import React from 'react';
import { EditableDealerInfo } from '../../../../lib/schema/dealer/types';
import { EditableBenefits, ReadonlyBenefits } from './Benefits';
import {
  EditableDetailedBenefits,
  ReadonlyDetailedBenefits,
} from './DetailedBenefits';
import Visibility from './Visibility';

interface DealerBenefitsProps {
  dealerName: string;
  editableDealerInfo: EditableDealerInfo;
  draftEditableDealerInfo: EditableDealerInfo;
  setDraftEditableDealerInfo: (value: EditableDealerInfo) => void;
  editing: boolean;
}

const DealerBenefits: React.FC<DealerBenefitsProps> = ({
  dealerName,
  editableDealerInfo,
  draftEditableDealerInfo,
  setDraftEditableDealerInfo,
  editing,
}) => {
  return (
    <div className="relative pt-3xl ml:pb-xl">
      {editing && (
        <div className="absolute right-0 top-l">
          <Visibility
            visible={draftEditableDealerInfo.showBenefitsSection}
            setVisible={(vis) =>
              setDraftEditableDealerInfo({
                ...draftEditableDealerInfo,
                showBenefitsSection: vis,
              })
            }
          />
        </div>
      )}

      {((!editing && editableDealerInfo.showBenefitsSection) || editing) && (
        <div className="mx-auto flex max-w-[1096px] flex-col justify-center gap-l ml:gap-xl">
          <div className="text-center text-h3SemiBold text-neutral-900 ml:text-h2SemiBold">
            Benefits of {dealerName}
          </div>

          {!editing && editableDealerInfo.detailedBenefits.length !== 0 && (
            <ReadonlyDetailedBenefits
              detailedBenefits={editableDealerInfo.detailedBenefits}
            />
          )}
          {editing && (
            <EditableDetailedBenefits
              detailedBenefits={draftEditableDealerInfo.detailedBenefits}
              setDetailedBenefits={(detailedBenefits) =>
                setDraftEditableDealerInfo({
                  ...draftEditableDealerInfo,
                  detailedBenefits,
                })
              }
            />
          )}

          {!editing && editableDealerInfo.benefitsList.length !== 0 && (
            <ReadonlyBenefits benefits={editableDealerInfo.benefitsList} />
          )}
          {editing && (
            <EditableBenefits
              benefits={draftEditableDealerInfo.benefitsList}
              setBenefits={(newBenefits) =>
                setDraftEditableDealerInfo({
                  ...draftEditableDealerInfo,
                  benefitsList: newBenefits,
                })
              }
            />
          )}
        </div>
      )}
    </div>
  );
};

export default DealerBenefits;
